<template>
  <div>
    <div class="consulting-title">提供服务</div>
    <div class="consulting-line"></div>
    <div class="he50"></div>
    <div class="img-box w-main">
      <div class="item2-img">
        <img src="../../../../assets/img/consulting/item1.png" alt />
        <p>现代航运服务业</p>
      </div>
      <div class="item2-img">
        <img src="../../../../assets/img/consulting/item2.png" alt />
        <p>第三方海事评估</p>
        <p>咨询、评估、鉴定</p>
      </div>
      <div class="item2-img">
        <img src="../../../../assets/img/consulting/item3.png" alt />
        <p>完整和提升航运</p>
        <p>产业的价值链</p>
      </div>
    </div>
    <div class="he50"></div>
    <div class="item2">
      <div class="consulting-title">技术咨询范围</div>
      <div class="consulting-line"></div>
      <div class="he50"></div>
      <div class="item-img">
        <img src="../../../../assets/img/consulting/bg.png" alt />
      </div>
      <div class="he50"></div>
    </div>
    <div class="he50"></div>
    <div class="consulting-title">我们的优势</div>
    <div class="consulting-line"></div>
    <div class="he50"></div>
    <div class="item3 w-main">
      <div class="item3-title">
        39家会员单位涉及航运各专业领域，长期积累专家库汇聚各专业高级技术人员。
      </div>
      <div class="he10"></div>
      <div class="item3-text">
        在上海市科协系统，能获得跨领域跨学科的技术支持。学会拥有市科协水路运输类科技评价资质。
        学会专家团队都具备高级工程师以上职称和深厚的从业经验，对海事海商领域的技术咨询起着重要的保证作用。
        每一个咨询项目都由精心组成的业界权威专家独立完成，
        保证了第三方的独立、公正，其良好的专业素质赢得了业界及社会相关领域的信誉。
      </div>
    </div>
    <div class="he50"></div>
    <div class="item3-box w-main">
      <div class="list">
        <div class="list-title">海事海商技术咨询精选案例</div>
        <div class="left-text">
          <span class="left-icon"></span>
          “秋锦”轮2007.06.18主机齿轮损坏原因技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          菲律宾苏里高装运散装红土镍矿至海南洋浦港的航次租船合同纠纷技术咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “Siboney
          Belle”轮第47航次在航行途中4节火车敞车车皮滑落海中事故原因的咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “浙海358”轮触碰乌沙山电厂码头技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          荷兰郁金香货损案专家咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          上海船东互保协会方式和途径课题研究
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          关于“Dong Fang Ocean”轮在船厂修理期间保险费纠纷技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          关于更换瓦锡兰主机工程及其所涉费用、时间技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “VEGA SCORPIO”轮1136W航次中货损原因技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “安广江”轮154航次甲板上球磨机落海原因技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “畅锦”11轮于2013年1月1日沉没原因技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “东方179”轮油浆损失计算技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “CHOU SHAN”轮与“CMA CGA FLORIDA”轮碰撞事故原因与责任技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “FC GLORIA”轮于2012年2月2日涉嫌苯酚泄漏和污染事故专家论证意见
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “CCL
          OSAKA”轮与“长航希望”轮及“金增18”轮与“长航希望”轮碰撞事故原因与责任技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          江苏省仪征市“11.9”自排水休闲观光船爆炸案技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “SAPAI”轮与“HOUYO”轮碰撞事故原因技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “宏泰顺”轮与“VERA 9”轮碰撞案技术咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          大连8.6嘉诚99轮沉没技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          闽东丛贸造船仲裁案专家咨询咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          嘉诚99轮沉没原因技术分析报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          “FPMC Container8”轮与“浙象渔49201”涉嫌发生碰撞技术分析
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          密斯姆轮与竞帆1轮-碰撞进水溢油事故中救助措施合理性技术分析
        </div>
      </div>
      <div class="list">
        <div class="list-title">水工类通航安全影响论证及评估精选案例</div>
        <div class="left-text">
          <span class="left-icon"></span>
          上海吴淞口地区长航锚地外侧建造大型国际油轮码头邮轮靠泊和通航环境技术可行性研究
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          九段沙湿地自然保护区浦东码头工程通航安全评估报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          上海吴淞口国际邮轮码头运营水上安全管理研究
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          世博园区庆典广场北侧大型音乐喷泉水景项目对黄浦江通航安全影响咨询报告
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          黄浦江过驳作业区浮吊通航安全影响评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          嵊泗沈家湾客运中心二期工程通航安全影响评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          沪通铁路吴淞口黄浦江越江隧道工程通航安全影响论证
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          东海大桥防碰撞方案论证
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          薄刀嘴岛至大洋山岛35KV海缆工程施工方案通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          长兴-横沙车客渡改扩建工程施工方案通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          黄浦江沿岸原上海外轮修理厂段游艇码头工程方案设计通航安全影响论证
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          启东市崇启大桥至三河港长江岸线综合整治工程涉河建设施工方案通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          石洞口燃气生产和能源储备建设项目配套码头新增泊位方案通航安全影响论证
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          昆阳路越江及配套道路工程—巨潮港锚地迁建工程施工方案通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          上海市天然气主干管网崇明岛-长兴岛-浦东新区五号沟LNG站管道工程项目施工通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          南汇东滩促淤工程--促淤二期工程（II标）通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          结合横沙造地应急处置工程泥浆试点工程（沿江通道越江隧道工程）通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          杨浦滨江公共空间和综合环境（五期）水上工程通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          N503（安迅一号）项目出海拖航（含回拖）以及海上推进器安拆作业通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          长平轮打捞施工通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          长江上海段航道疏浚维护A标施工通航安全评估
        </div>
        <div class="left-text">
          <span class="left-icon"></span>
          长江口南槽航道治理一期工程疏浚工程施工通航安全保障方案
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
//
</style>
